import { FinalGrade } from 'app/library/final-grade/models/final-grade.model';
import { ModuleUserExtended } from 'app/library/module-user/models/module-user.extended.model';
import { IProgramStructureWithProgramparticipantQuery } from '../interfaces/program-structure-with-program-participant.query.interface';
import { ProgramItemsWithGroup } from './program-items-with-group.model';

// @dynamic
export class ProgramStructureWithProgramParticipant {
    programFinalGrade: FinalGrade;
    programParticipant: ModuleUserExtended;
    programStructure: ProgramItemsWithGroup[];

    constructor(query: IProgramStructureWithProgramparticipantQuery) {
        if (query) {
            this.programFinalGrade = new FinalGrade(query.program_final_grade);
            this.programParticipant = new ModuleUserExtended(query.program_participant);
            this.programStructure = query.program_structure.length ? query.program_structure.map((programItem) => new ProgramItemsWithGroup(programItem)) : [];
        }
    }
}
